import React from 'react';
import { Box } from '@mui/material';

/**
 * TabPanel component to display content for a specific tab
 * @param {Object} props - Component props
 * @param {number} props.value - Current active tab index
 * @param {number} props.index - This tab's index
 * @param {React.ReactNode} props.children - Content to display when this tab is active
 * @param {Object} props.sx - Additional styles to apply to the container
 * @returns {JSX.Element} TabPanel component
 */
const TabPanel = ({ children, value, index, sx = {}, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ 
        height: '100%', 
        display: value === index ? 'flex' : 'none',
        flexDirection: 'column',
        overflow: 'hidden',
        maxWidth: '100%',
        overflowX: 'hidden'
      }}
      {...other}
    >
      <Box 
        sx={{ 
          height: '100%', 
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          ...sx 
        }}
      >
        {children}
      </Box>
    </div>
  );
};

export default TabPanel;
